import React, { useEffect, useState } from "react";
import Loader from "../../../../components/Loader";
import AppraisalCongirmationModal from "../../../../components/modelpopup/AppraisalCongirmationModal";
import { formatDateInTimezone } from "../../../../utils/formatDateInTimezone";
import api from "../../../../api/axios";

const PerformanceAppraisalCard = ({ data, year, getAllMainGoalData }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [description, setDescription] = useState("");
  const [fieldsError, setFieldsError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [show, setShow] = useState(false);
  const [overAllAppraisal, setOverAllAppraisal] = useState(0);
  const [overAllAverageRating, setOverAllAverage] = useState(0);

  // Function to calculate overall average rating
  function calculateOverallAverageRating(data) {
    if (!Array.isArray(data) || data.length === 0) return 0;
    const totalRating = data.reduce(
      (sum, item) => sum + item.average_rating,
      0
    );
    return totalRating / data.length;
  }

  // Function to calculate overall appraisal percentage
  function calculateOverallAppraisal(data) {
    if (!Array.isArray(data) || data.length === 0) {
      return 0; // Return 0 if data is empty or not an array
    }
    const totalRating = data.reduce(
      (sum, item) => sum + parseFloat(item.final_appraisal || 0),
      0
    );
    console.log("totalRating:", totalRating);
    const appraisal = totalRating / data.length; // Debugging
    return appraisal;
  }

  const handleEditClick = (goal, appraisal) => {
    setIsEditing(true);
    setOverAllAppraisal(goal?.final_evaluation || appraisal);
    setDescription(goal?.appraisal_description || "");
  };

  // Handle save button click
  const handleSaveClick = () => {
    if (isEditing) {
      let errors = {};
      if (!overAllAppraisal)
        errors.tempAppraisal = "Appraisal Value is required";
      if (!description) errors.reason = "Reason is required";

      if (Object.keys(errors).length > 0) {
        setFieldsError(errors);
        return;
      }
    }
    setShow(true);
  };

  // Handle cancel button click
  const handleCancelClick = () => {
    setIsEditing(false);
    setOverAllAppraisal(0);
    setDescription("");
    setFieldsError({});
  };

  // Handle modal close
  const handleClose = () => {
    setShow(false);
  };

  // Submit modified appraisal data
  const submitAppraisalData = async () => {
    const editedData = {
      description,
      overAllAppraisal,
      original_evaluation: calculateOverallAppraisal(data),
    };
    const employeeId = localStorage.getItem("employeeID");

    try {
      setIsLoading(true);
      const response = await api.post(
        `performance/modify-appraisal?reviewer_id=${employeeId}&year=${data[0]?.year}&employee_id=${data[0]?.employee_id}`,
        { editedData, data }
      );

      if (response?.data?.success) {
        getAllMainGoalData(data[0]?.employee_id, data[0]?.year);
        setShow(false);
        setIsEditing(false);
        setIsLoading(false);
        setIsSubmitted(true);
      }
    } catch (err) {
      console.log("Error submitting appraisal:", err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data.length > 0) {
      setOverAllAverage(calculateOverallAverageRating(data));
      setOverAllAppraisal(calculateOverallAppraisal(data));
    }
  }, [data]);

  return (
    <>
      {isLoading && <Loader show={isLoading} />}
      <div className="p-4 border rounded-lg shadow-md bg-white">
        <div className="mt-4">
          {/* <h3 className="text-lg font-bold">
            Over All Average Rating: {overAllAverageRating} / {data[0]?.out_of}
          </h3> */}
          <h3 className="text-lg font-bold mt-2">
            Total Appraisal
            {!data[0]?.employee_final_appraisal_release_id && !isEditing ? (
              <i
                className="fas fa-edit ml-5 cursor-pointer"
                style={{
                  fontSize: "14px",
                  marginLeft: "15px",
                  color: "#1fb2c2",
                  cursor: "pointer",
                }}
                onClick={() =>
                  handleEditClick(data, calculateOverallAppraisal(data))
                }
              ></i>
            ) : (
              !data[0]?.employee_final_appraisal_release_id && (
                <i
                  className="fas fa-times cursor-pointer text-red-500"
                  style={{
                    fontSize: "16px",
                    marginLeft: "15px",
                    color: "red",
                    cursor: "pointer",
                  }}
                  onClick={handleCancelClick}
                ></i>
              )
            )}
          </h3>

          {!isEditing ? (
            <>
              {data[0]?.original_evaluation &&
                data[0]?.original_evaluation != data[0]?.final_evaluation && (
                  <span>
                    Original Appraisal Percentage:{" "}
                    {data[0]?.original_evaluation}%
                  </span>
                )}
              <br />
              <span className="text-gray-600">
                Final Released Appraisal Percentage:{" "}
                {data[0]?.final_evaluation || calculateOverallAppraisal(data)}%
              </span>
              <br />
              {(description || data[0]?.release_description) && (
                <span>
                  Reason for Adjustment:{" "}
                  {data[0]?.release_description || description}
                </span>
              )}
              <br />
              {data[0]?.release_appraisal_updated_at && (
                <span>
                  Appraisal Date:{" "}
                  {formatDateInTimezone(data[0]?.release_appraisal_updated_at)}
                </span>
              )}
              <br />
              {data[0]?.release_appraisal_created_by_first_name && (
                <span>
                  Evaluated By:{" "}
                  {data[0]?.release_appraisal_created_by_first_name}{" "}
                  {data[0]?.release_appraisal_created_by_middle_name || ""}{" "}
                  {data[0]?.release_appraisal_created_by_last_name}
                </span>
              )}
            </>
          ) : (
            <div className="row mt-3 flex items-center justify-content-between">
              <div className="col-md-6">
                <input
                  type="text"
                  value={overAllAppraisal}
                  onChange={(e) => {
                    setOverAllAppraisal(e.target.value);
                    setFieldsError((prev) => ({ ...prev, tempAppraisal: "" }));
                  }}
                  className="border rounded p-2 w-100"
                  placeholder="Enter Appraisal Score"
                />
                {fieldsError?.tempAppraisal && (
                  <span className="text-danger">
                    *{fieldsError?.tempAppraisal}
                  </span>
                )}
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    setFieldsError((prev) => ({ ...prev, reason: "" }));
                  }}
                  placeholder="Enter Reason"
                  className="border rounded p-2 w-100"
                />
                {fieldsError?.reason && (
                  <span className="text-danger">*{fieldsError?.reason}</span>
                )}
              </div>
            </div>
          )}

          <div className="text-end mt-5">
            <button
              className="btn btn-primary"
              onClick={handleSaveClick}
              disabled={
                data[0]?.employee_final_appraisal_release_id ||
                data?.length == 0
                  ? true
                  : false
              }
            >
              Submit Appraisal
            </button>
          </div>
        </div>
      </div>
      <AppraisalCongirmationModal
        handleClose={handleClose}
        show={show}
        submitAppraisalData={submitAppraisalData}
        data={data}
        overAllAppraisal={overAllAppraisal}
      />
    </>
  );
};

export default PerformanceAppraisalCard;
